// extracted by mini-css-extract-plugin
export default {"menu":"versionPanel_menu__8nfnN","btn":"versionPanel_btn__yQYX+","icon":"versionPanel_icon__y17ra"};